<template>
  <span>
    <v-select :value.sync="selected" :options="orgList" :on-search="loadOrgList" :on-change="changeCallback"
    placeholder="Search for Institution..."></v-select>
  </span>
</template>

<script>
  import vSelect from 'vue-select'
  import CommonDataService from '../endpoints/CommonDataService'
  import { debounce } from 'lodash'

  export default {
    name: 'org-input',
    components: {vSelect},
    model: {
      prop: 'value',
      event: 'change'
    },
    props: ['value'],
    data () {
      return {
        orgList: [],
        selected: this.value
      }
    },
    watch: {
      selected: function (val) {
        this.$emit('change', val[0].value)
      }
    },
    methods: {
      loadOrgList: debounce(function (search, loading) {
        loading(true)
        let self = this

        CommonDataService.searchOrgs(search)
          .then(response => {
            self.orgList = response.data
            loading(false)
          })
          .catch(error => {
            self.error = error.message
          })
      }, 500),
      changeCallback (val) {
        this.$emit('change', parseInt(val.value))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/OrgLovComponent.vue